/**
 * Constants
 */
/** @private */
export var cellClick = 'cellClick';
/** @private */
export var cellDoubleClick = 'cellDoubleClick';
/** @private */
export var moreEventsClick = 'moreEventsClick';
/** @private */
export var select = 'select';
/** @private */
export var hover = 'hover';
/** @private */
export var actionBegin = 'actionBegin';
/** @private */
export var actionComplete = 'actionComplete';
/** @private */
export var actionFailure = 'actionFailure';
/** @private */
export var navigating = 'navigating';
/** @private */
export var renderCell = 'renderCell';
/** @private */
export var eventClick = 'eventClick';
/** @private */
export var eventDoubleClick = 'eventDoubleClick';
/** @private */
export var eventRendered = 'eventRendered';
/** @private */
export var dataBinding = 'dataBinding';
/** @private */
export var dataBound = 'dataBound';
/** @private */
export var popupOpen = 'popupOpen';
/** @private */
export var popupClose = 'popupClose';
/** @private */
export var dragStart = 'dragStart';
/** @private */
export var drag = 'drag';
/** @private */
export var dragStop = 'dragStop';
/** @private */
export var resizeStart = 'resizeStart';
/** @private */
export var resizing = 'resizing';
/** @private */
export var resizeStop = 'resizeStop';
/** @private */
export var inlineClick = 'inlineClick';
/** @private */
export var cellSelect = 'cellSelect';
/** @private */
export var virtualScrollStart = 'virtualScrollStart';
/** @private */
export var virtualScrollStop = 'virtualScrollStop';
/**
 * Specifies schedule internal events
 */
/** @private */
export var initialLoad = 'initial-load';
/** @private */
export var initialEnd = 'initial-end';
/** @private */
export var print = 'print';
/** @private */
export var dataReady = 'data-ready';
/** @private */
export var eventsLoaded = 'events-loaded';
/** @private */
export var contentReady = 'content-ready';
/** @private */
export var scroll = 'scroll';
/** @private */
export var virtualScroll = 'virtual-scroll';
/** @private */
export var scrollUiUpdate = 'scroll-ui-update';
/** @private */
export var uiUpdate = 'ui-update';
/** @private */
export var documentClick = 'document-click';
/** @private */
export var cellMouseDown = 'cell-mouse-down';
